import { render, staticRenderFns } from "./ChatGptMessages.vue?vue&type=template&id=8c1f294e&scoped=true"
import script from "./ChatGptMessages.vue?vue&type=script&lang=js"
export * from "./ChatGptMessages.vue?vue&type=script&lang=js"
import style0 from "./ChatGptMessages.vue?vue&type=style&index=0&id=8c1f294e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1f294e",
  null
  
)

export default component.exports